/* eslint-disable */
// Custom queries/mutations for ShareableMedia

export const shareableMediaByShareId = /* GraphQL */ `
  query ShareableMediaByShareId($shareId: String!, $limit: Int) {
    shareableMediaByShareId(shareId: $shareId, limit: $limit) {
      items {
        id
        shareId
        storyId
        userId
        mediaType
        s3Key
        title
        storytellerName
        photoS3Key
        sourceType
        createdAt
        owner
      }
      nextToken
    }
  }
`;

export const shareableMediaByUserId = /* GraphQL */ `
  query ShareableMediaByUserId($userId: String!, $limit: Int) {
    shareableMediaByUserId(userId: $userId, limit: $limit) {
      items {
        id
        shareId
        storyId
        userId
        mediaType
        s3Key
        title
        storytellerName
        photoS3Key
        sourceType
        createdAt
        owner
      }
      nextToken
    }
  }
`;

export const createShareableMedia = /* GraphQL */ `
  mutation CreateShareableMedia($input: CreateShareableMediaInput!) {
    createShareableMedia(input: $input) {
      id
      shareId
      storyId
      userId
      mediaType
      s3Key
      title
      storytellerName
      photoS3Key
      sourceType
      createdAt
    }
  }
`;

export const deleteShareableMedia = /* GraphQL */ `
  mutation DeleteShareableMedia($input: DeleteShareableMediaInput!) {
    deleteShareableMedia(input: $input) {
      id
      shareId
    }
  }
`;
